import { Templates, WixFlow } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect, useMemo } from 'react'

import { HttpFunnelBuilderService } from '../../api/FunnelBuilderService/FunnelBuilderService'
import { FlowLoggerProvider, PageLoggerProvider } from '../../bi/mfi'
import { useDebugTranslationKeys } from '../../hooks/useDebugTranslationKeys'
import { useFlowContext } from '../../hooks/useFlowContext'
import { useForceLanguage } from '../../hooks/useForceLanguage'
import { useForcePage } from '../../hooks/useForcePage'
import { usePageId } from '../../hooks/usePageId'
import { enrichSentry } from '../../monitoring/enrichSentry'
import { SkeletonLoader } from '../SkeletonLoader/SkeletonLoader'
import { AppTemplates } from './AppTemplates'
import { TemplatesFallback } from './TemplatesFallback'

export const AppInStorageProvider: FC = () => {
  const [flowContext, setFlowContext] = useFlowContext()
  const pageId = usePageId()
  const forcePage = useForcePage()
  const forceLanguage = useForceLanguage()
  const debugTranslationKeys = useDebugTranslationKeys()

  const flowId = flowContext?.historyEntries[0]?.flowId ?? 'preview'
  const funnelBuilderService = useMemo(() => new HttpFunnelBuilderService(flowId), [flowId])

  const flowBiSlug = flowContext?.metadata?.biSlug || 'unknown'
  const metaSiteId = flowContext?.metadata?.metaSiteId

  useEffect(() => {
    enrichSentry(flowContext)
  }, [flowContext])

  if (!flowContext && !pageId) {
    window.location.replace('https://www.wix.com/website/templates')
    return null
  }

  return (
    <FlowLoggerProvider flowBiSlug={flowBiSlug} metaSiteId={metaSiteId}>
      <WixFlow
        flowContext={flowContext}
        updateFlowContext={setFlowContext}
        service={funnelBuilderService}
        fallback={() => <TemplatesFallback flowId={flowId} />}
      >
        <Templates
          Loader={SkeletonLoader}
          pageId={pageId}
          forcePage={forcePage}
          forceLanguage={forceLanguage}
          debugTranslationKeys={debugTranslationKeys}
        >
          <PageLoggerProvider>
            <AppTemplates />
          </PageLoggerProvider>
        </Templates>
      </WixFlow>
    </FlowLoggerProvider>
  )
}
